'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { setPrefillEmail } from '@/lib/auth/prefill-email';

/** Legacy reset URL: recovery now starts and completes on /confirm. */
export default function Page() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const email = searchParams.get('email');
    if (email) setPrefillEmail(email);
    router.replace('/reset-password/confirm');
  }, [router, searchParams]);

  return null;
}
